module.exports = __webpack_public_path__ + "static/img/game-rating.4de5570.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/game-rating.jpeg
// module id = uHnm
// module chunks = 13